import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, styled } from '@nextiva/next-ui-components';
import { actionTypes } from 'containers/pages/Teams/redux';

import { formatPhoneNumber } from 'utils/formatters';

import { TeamActions } from '../TeamActions';

const StyledusersDiv = styled('div')`
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-left: 5px;
  }
`;
const StyledphoneNumerDiv = styled('div')`
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-left: 10px;
  }
`;
const StyledExtensionDiv = styled('div')`
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-left: 15px;
  }
`;

export const TeamRow = ({
  team,
  team: { extension, name, phoneNumber, durableCallGroupId, userCount },
  style = {},
  onEditTeam,
}) => {
  const dispatch = useDispatch();

  const handleEditTeam = useCallback(() => {
    dispatch({
      type: actionTypes.SET_EDIT_TEAM_INFO,
      editTeamInfo: team,
    });

    onEditTeam();
  });

  return (
    <Grid style={style}>
      <Grid
        container
        alignItems="center"
        className="Body m-table-row"
        data-testid="PlatformAdminUI-TeamsLink-TeamRow-TableBody"
      >
        <Grid item xs={3}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-TeamsLink-TeamRow-TeamName"
          >
            {name}
          </div>
        </Grid>
        <Grid item xs={3}>
          <StyledusersDiv
            className="m-table-row__data"
            data-testid="PlatformAdminUI-TeamsLink-TeamRow-UserCount"
          >
            {userCount} {userCount === 1 ? 'user' : 'users'}
          </StyledusersDiv>
        </Grid>

        <Grid item xs={3}>
          <StyledphoneNumerDiv
            className="m-table-row__data"
            data-testid="PlatformAdminUI-TeamsLink-TeamRow-PhoneNumber"
          >
            {formatPhoneNumber(phoneNumber)}
          </StyledphoneNumerDiv>
        </Grid>

        <Grid item xs={3}>
          <Grid container alignItems="center">
            <Grid item xs={8}>
              <StyledExtensionDiv
                className="m-table-row__data"
                data-testid="PlatformAdminUI-TeamsLink-TeamRow-Extension"
              >
                {extension}
              </StyledExtensionDiv>
            </Grid>
            <Grid item xs={4}>
              <div
                className="actionBase--selector"
                data-testid="PlatformAdminUI-TeamsLink-TeamRow-ActionsButton"
              >
                <TeamActions
                  onEditTeam={handleEditTeam}
                  huntGroup={durableCallGroupId}
                  team={team}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
